module.exports = __webpack_public_path__ + "static/media/success-tick-green-mark.e68bea93.svg";